export const setFormValues = (setter) => (values) => {
  Object.entries(values).forEach(([key, value]) => {
    setter(key, value, { shouldValidate: false });
  });
};
